export const isTableDividerRow = (value: string): boolean => {
  const trimmedValue = value.trim()

  if (!trimmedValue.startsWith('|') || !trimmedValue.endsWith('|')) {
    return false
  }

  const dividerCells = trimmedValue.slice(1, -1).split('|')
  if (dividerCells.length === 0) {
    return false
  }

  return dividerCells.every(cell => /^\s*:?-{3,}:?\s*$/.test(cell))
}
